// Membaca isian <form> (dipakai di submit modal).

/** Nilai isian form berdasarkan nama ('' bila tidak ada). */
export const fv = (f: HTMLFormElement, n: string): string =>
  (f.elements.namedItem(n) as HTMLInputElement | HTMLSelectElement | null)?.value ?? '';
